import React, { useEffect } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { SignIn } from './components/auth/signin.jsx'

import { PrivateRoute } from './components/auth/privateRoute.jsx'
import { Signout } from './components/auth/signout.jsx'

import Explore from './components/Explore'
import Preview from './components/Preview'
import EditProfile from './screens/edit-profile/EditProfile'

// TODO: query params both formats

// {lng:double=-6}/{lat:double=44}/{zoom:double=3}/{locationId:guid=00000000-0000-0000-0000-000000000000}/{postId:guid=00000000-0000-0000-0000-000000000000}/{postAuthorId:guid=00000000-0000-0000-0000-000000000000}", Name = nameof(ChartController) + nameof(ChartController.Index)
function App() {
  // I've updated the books and social backends to have permalinks for Locations and SocialPosts.
  // You can retrieve them via their permalink instead of the Id using the following API endpoints:
  // Location:https://books.imray.dev/bookNode/api/getBookNodeByPermalink/{permalink}
  // SocialPost:https://social.imray.dev/api/socialPost/getSocialPostByPermalink/{permalink}
  // permalink

  useEffect(() => {
    // ref: https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    function setDocHeight() {
      window.addEventListener('resize', () => {
        let vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty('--vh', `${vh}px`)
      })
    }

    window.addEventListener('resize', setDocHeight)
    setDocHeight()

    return () => {
      window.removeEventListener('resize', setDocHeight)
    }
  }, [])

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/signin-oidc/*" element={<SignIn />} />
          <Route path="/logout/*" element={<Signout />} />
          <Route path="/*" element={<PrivateRoute />}>
            <Route path="/*" element={<Explore />} />
            <Route path="chart/*" element={<Explore />} />
            <Route path="edit-profile/*" element={<EditProfile />} />
          </Route>
          <Route
            path={'/preview/:lng?/:lat?/:zoom?/:postId?/:authorId?/'}
            element={<Preview />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default App
